import React from "react";

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 110">
      <g data-name="Layer 2">
        <path fill="none" d="M0 0h150v110H0z" data-name="Rectangle 15168" />
        <g data-name="Group 1413">
          <g data-name="Group 1407">
            <g
              fill="none"
              stroke="#424242"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="3"
              data-name="Group 1383"
            >
              <path d="M92.57 62.16V42.75H53.94v35.32h22.22" data-name="Path 1177" />
              <path d="M88.6 65v14.92" data-name="Line 88" />
              <path d="M96.06 72.46H81.14" data-name="Line 89" />
              <path
                d="M62.76 48v-7.4a10.5 10.5 0 0110.5-10.5h0a10.5 10.5 0 0110.5 10.5h0V48"
                data-name="Path 1178"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default Icon;
